import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const products = [
  {
    name: 'Tiger Prawns',
    spec: '30–40 count/kg, Peeled & Deveined',
    pack: '500 g pack',
    price: '₹ 549',
    badge: 'Frozen at Peak',
    image: 'https://readdy.ai/api/search-image?query=Premium%20frozen%20tiger%20prawns%20in%20modern%20retail%20vacuum%20pack%20on%20white%20marble%20surface%2C%20warm%20kitchen%20setting%2C%20appetizing%20food%20photography%2C%20soft%20natural%20lighting%2C%20high%20detail%20close-up%2C%20clean%20packaging%20design&width=600&height=400&seq=freshhlock-sku-retail-prawns&orientation=landscape',
  },
  {
    name: 'Basa Fillets',
    spec: '200–250g each, Skinless & Boneless',
    pack: '1 kg pack (4–5 fillets)',
    price: '₹ 399',
    badge: 'Best Seller',
    image: 'https://readdy.ai/api/search-image?query=Frozen%20white%20fish%20fillets%20in%20premium%20retail%20packaging%20on%20clean%20light%20kitchen%20surface%2C%20appetizing%20presentation%2C%20warm%20natural%20lighting%2C%20high%20detail%20food%20product%20photography%2C%20modern%20packaging&width=600&height=400&seq=freshhlock-sku-retail-basa&orientation=landscape',
  },
  {
    name: 'Chicken Breast',
    spec: 'Boneless, Skinless, IQF',
    pack: '1 kg pack',
    price: '₹ 449',
    badge: 'Frozen at Peak',
    image: 'https://readdy.ai/api/search-image?query=Frozen%20chicken%20breast%20portions%20in%20modern%20retail%20packaging%20on%20white%20kitchen%20counter%2C%20clean%20appetizing%20food%20product%20photography%2C%20warm%20natural%20lighting%2C%20high%20detail%2C%20professional%20styling&width=600&height=400&seq=freshhlock-sku-retail-chicken&orientation=landscape',
  },
  {
    name: 'Green Peas',
    spec: 'Grade A, 8–9mm, IQF',
    pack: '1 kg pack',
    price: '₹ 149',
    badge: 'Value Pick',
    image: 'https://readdy.ai/api/search-image?query=Frozen%20green%20peas%20in%20modern%20retail%20packaging%20on%20light%20wood%20kitchen%20surface%2C%20bright%20fresh%20green%20color%2C%20clean%20food%20product%20photography%2C%20warm%20natural%20lighting%2C%20high%20detail&width=600&height=400&seq=freshhlock-sku-retail-peas&orientation=landscape',
  },
];

export default function FeaturedSKUs() {
  const { ref, revealed } = useScrollReveal();
  const [activeIndex, setActiveIndex] = useState(0);

  const visibleProducts = products.slice(activeIndex, activeIndex + 4);

  return (
    <section className="py-20 md:py-28 warm-sand-bg">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            Featured Products
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            This Month&apos;s Top Picks
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto">
            Our most-loved products, hand-picked by our quality team. Frozen at peak, delivered with full traceability.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {visibleProducts.map((product, i) => (
            <div
              key={i}
              className="group bg-card-50 rounded-xl overflow-hidden border border-card-200 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 cursor-pointer card-animate"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-semibold rounded-full bg-accent-500/90 text-brand-800">
                    {product.badge}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-primary-700 mb-1">{product.name}</h3>
                <p className="text-xs text-foreground-400 mb-1">{product.spec}</p>
                <p className="text-xs text-foreground-400 mb-3">{product.pack}</p>
                <div className="flex items-center justify-between">
                  <span className="font-heading text-lg font-bold text-accent-600">{product.price}</span>
                  <button className="px-4 py-2 bg-brand-700 hover:bg-brand-600 text-paper-50 text-xs font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}